export enum AnnouncementsListRouterLinks {
  List = "announcements-list",
}
